<template>
    <div class="announdialog">
        <el-dialog
        class="pub_dialog"
        title="订单信息确认"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        :lock-scroll="false"
        :destroy-on-close="true"
        width="60%">
        <div class="dialogs">
            <p>公告名称：<span>{{noticedet.title}}</span></p>
            <p>公告类型：<span>{{noticedet.typeName}}</span></p>
            <p>发布时间：<span>{{noticedet.createDate}}</span></p>
            <p>开始时间：<span>{{noticedet.startTime}}</span></p>
            <p>结束时间：<span>{{noticedet.endTime}}</span></p>
            <div v-html="noticedet.content"></div>
            <div>
            <p>附件信息:</p>
            <ul>
                <!-- <li class="mt8 cursorP" :style="{'color':theme}" @click="downloadfile(item)" v-for="(item,index) in noticedet.files" :key="index">{{item.fileName}}</li> -->
                <li class="mt8 cursorP" :style="{'color':theme}" v-for="(item,index) in noticedet.files" :key="index">
                    <a :href="`/upload/downloadController/download?objectName=${item.objectName}`" :download="item.name">{{item.fileName}}</a>
                </li>
            </ul>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="Cancel">取 消</el-button>
            <el-button size="small" type="primary" @click="Save">确 定</el-button>
        </span>
    </el-dialog>
    </div>
</template>
<script>
import {ReadNotice} from '@/api/api';
import {download} from '@/utils/index';
import { mapGetters } from 'vuex'
export default {
    data(){
        return{
            
        }
    },
    props: {
        visible: { //是否显示
            type: Boolean,
            default: false
        },
        noticedet:{
            type:Object,
            default:function(){
                return {}
            }
        }
    },
    created(){
        this.getNoticeContent(this.noticedet.id)
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
            }
        },
        // 主题色
        ...mapGetters({
            theme: 'theme'
        })
    },
    methods:{
                /**
         * @description: 通过id获取公告信息 ，如果是未阅读，需要请求接口重新标记
         * @param {*} params id 
         * @return {*}
         * @author: txp
         */
        getNoticeContent(params){
            if(this.noticedet.msgStateName == "未读"){
                this.Rednotice(params)
            }
        },
        // 请求阅读接口
        Rednotice(params){
            ReadNotice({noticeId:params}).then(res=>{
                if(res.code == 200){
                }
            }).catch(error=>{
                this.$message.error(error)
            })
        },
        // 
        // // 文件下载
        // downloadfile(files){
        //     download(`${files.url}?response-content-type=application/octet-stream`,files.fileName)
        // },
        // 取消
        Cancel () {
            this.$emit('resetPopupData')
        },
        // 确定
        Save () {
            this.$emit('submitPopupData')
        },
        // 关闭
        handleClose () {
            this.$emit('handleClose')
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
